<template>
    <div class="card bg-white p-2 mb-2"  :class="'border-'+color" >
    <small class=" pb-0" :class="'text-'+color"><i class="icon-info mr-2"></i>{{message}}</small>
    </div>
</template>

<script>


export default { 
  props: {
    message: String,
    color: String
  },


  methods: {
    
  }
};
</script>
